// @ts-ignore
import React from "react";

import { useIntl } from "react-intl";

import { Picture } from "@/components/wpl/image/src/index.ts";

export const Hero = () => {
    const intl = useIntl();
    return (
        <Picture
            image={{
                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/5j2mvlle35t45d0e48ye5tqpoe0m63gu.svg",
                alt: intl.formatMessage({
                    id: "StrategyCollectionPricingPageTemplate.headingLogoAlt",
                    defaultMessage: "Strategy Collection logo"
                })
            }}
        />
    );
};
